/**
 * Post-login redirect helpers.
 *
 * Preserves the deep link (path + query) the user originally requested
 * across the Cognito login round-trip. Stored in sessionStorage — the
 * login redirect happens in the same tab, so the value survives it
 * (same mechanism as the PKCE verifier).
 */

const STORAGE_KEY = 'beacon_post_login_redirect';

/** Stash the current path + query so the callback can return to it. */
export const stashPostLoginRedirect = (): void => {
  const target = window.location.pathname + window.location.search;
  sessionStorage.setItem(STORAGE_KEY, target);
};

/**
 * Retrieve and consume the stashed redirect (one-time use).
 * Returns '/' when nothing was stashed or the value is not a safe
 * same-origin relative path (guards against open redirects).
 */
export const consumePostLoginRedirect = (): string => {
  const target = sessionStorage.getItem(STORAGE_KEY);
  sessionStorage.removeItem(STORAGE_KEY);
  if (target && target.startsWith('/') && !target.startsWith('//')) {
    return target;
  }
  return '/';
};
